import {
  SAVE_ADDRESS,
} from '../actions/address';

const initialState = {};

export default function address(state = initialState, action) {
  switch (action.type) {
    case SAVE_ADDRESS:
      return action.address;
    default:
      return state;
  }
}
